import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IGameAssignmentContext,
	GameAssignmentContext,
} from '../../../../../gameAssignmentState/gameAssignmentContext';
import { Checkbox } from 'antd';
import style from './UnassignedCheckbox.module.scss';

const UnassignedCheckbox: React.FC = () => {
	const { toggleUnassignedGames, isUnassignedGames } = useContext<IGameAssignmentContext>(GameAssignmentContext);

	return (
		<Checkbox
			className={style.checkbox}
			onChange={toggleUnassignedGames}
			checked={isUnassignedGames}
			data-test="UnassignedCheckbox">
			<Text translationNameSpace="listing" translationKey="unassignedGamesLabel" asFragment={true} />
		</Checkbox>
	);
};

export default UnassignedCheckbox;
